import React from "react";
import {
  Form,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormInput
} from "shards-react";
import MenuBookIcon from '@material-ui/icons/MenuBook';

export default () => (
  <Form className="main-navbar__search w-100 d-none d-md-flex d-lg-flex">
    {/*<InputGroup seamless className="ml-3">
      <InputGroupAddon type="prepend">
        <InputGroupText>
          <i className="material-icons">search</i>
        </InputGroupText>
      </InputGroupAddon>
      <FormInput
        className="navbar-search"
        disabled
        placeholder="Busca algo aquí"
      />
    </InputGroup>*/}
    <div className="ml-auto my-auto mx-2">
      <MenuBookIcon onClick={() => {window.open(process.env.REACT_APP_MANUAL_URL,'_blank')}}
      />
    </div>
  </Form>
);
